import { render, staticRenderFns } from "./duoDiscover.vue?vue&type=template&id=b3c05c32&"
import script from "./duoDiscover.vue?vue&type=script&lang=js&"
export * from "./duoDiscover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports